import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { FilterHeaderComponent } from '../../filter-header/filter-header.component';
import { BaseFilterComponent } from '../base-filter.component';

@Component({
  selector: 'vectronic-deployed-only',
  imports: [FilterHeaderComponent, MatDividerModule],
  templateUrl: './deployed-only.component.html',
  styleUrl: './deployed-only.component.scss',
})
export class DeployedOnlyComponent extends BaseFilterComponent {}
